import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
const FormSkeletonLoader = ({height}) => {
    return(
        <div className='form-wrapper-head'>
            <Skeleton variant="rect" width={'100%'} height={height ? height : 42} />
        </div>
    )
}
export default FormSkeletonLoader;